import { gql } from '@apollo/client';

const TOPIC_FIELDS_FRAGMENT = gql`
  fragment TopicFields on Topic {
    id
    name
    description
    privacy
    memberEditable
    defaultSort
    defaultShow
  }
`;

export default TOPIC_FIELDS_FRAGMENT;
